import { useInfiniteQuery } from "@tanstack/react-query";
import { getAuditLog } from "apis/audit";
import { useAntdMessage } from "hooks/useAntdMessage";

export const useAuditLog = ({ payload = {} }, options = {}) => {
  const { message } = useAntdMessage();
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ["auditLogs", payload],
    queryFn: async ({ pageParam }) => {
      let response;
      try {
        const {
          data: { data },
        } = await getAuditLog({
          page: pageParam,
          ...payload,
        });
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage) {
        return undefined;
      }
      return lastPage.current_page < lastPage.last_page
        ? lastPage.current_page + 1
        : undefined;
    },
    onError: (error) =>
      message.error(
        error?.message ||
          error?.data?.message ||
          "Failed to load data from server!"
      ),
    keepPreviousData: true,
    ...options,
  });
};
